/**
 * Assertion.js
 * Created by calhosh on 11/6/2019.
 */
import React, {useState, useEffect} from 'react';
import styled from 'styled-components';
import AssertionBadge from '../AssertionBadge/AssertionBadge';
import {currentResource} from '../../../util/utils';

export default function Assertion(props) {
	const isActive = props.isActive ? 'active' : 'inactive';
	const {
		assertion,
		showName,
		showAssertionName,
		displayName,
		showCheckbox,
		checkboxDisabled,
		showExpandCollapse,
		checked,
		onCheckboxChange,
		noBackground,
		showAddedLabel,
		isAddTaskModal,
		showAbbreviationTooltipOnly,
		noBackgroundYesTooltip,
		inherentRiskView,
		customMinWidth
	} = props;

	const [isChecked, setChecked] = useState(checked);

	const onCheckboxChangeHandles = (e) => {
		setChecked(!isChecked);
		onCheckboxChange(e);
	};

	const hidden = assertion && assertion.notForDisplay ? 'hiddenAssertions' : '';

	// In Add Tasks.. for Account OSP, user should not be able to check mulitple accounts
	useEffect(() => {
		if (isAddTaskModal) {
			setChecked(assertion.checked);
		}
	}, [assertion]);

	return (
		<ListItem
			className={`assertion-item ${isActive} ${hidden} aid${assertion?.knowledgeAssertionId}`}
			id={assertion.id}
			onClick={() => {
				props.onClick();
			}}
		>
			<AssertionBadge
				id={assertion.id}
				assertion={assertion}
				showName={showName}
				displayName={
					displayName && displayName.length > 0
						? displayName
						: showAssertionName
						? currentResource.assertions[assertion.knowledgeAssertionId - 1]
							? currentResource.assertions[assertion.knowledgeAssertionId - 1].assertionname
							: assertion.assertionName
						: assertion.accountName
				}
				showCheckbox={showCheckbox}
				checked={isChecked}
				checkboxDisabled={checkboxDisabled}
				onCheckboxChange={onCheckboxChangeHandles}
				showExpandCollapse={showExpandCollapse}
				noBackground={noBackground}
				noBackgroundYesTooltip={noBackgroundYesTooltip}
				showAddedLabel={showAddedLabel}
				showAbbreviationTooltipOnly={showAbbreviationTooltipOnly}
				inherentRiskView={inherentRiskView}
				customMinWidth={customMinWidth}
			/>
		</ListItem>
	);
}

Assertion.defaultProps = {
	customMinWidth: 'var(--px-60)'
};

const ListItem = styled.li`
	display: inline-flex;
	line-height: normal;
	min-width: ${(props) => props.customMinWidth};
	margin-right: var(--px-10) !important;
	&.hiddenAssertions {
		visibility: hidden;
	}
	&:last-child {
		margin-right: 0 !important;
	}
	&:nth-child(4) {
		.show-pop-content.bottom.left {
			left: auto;
			right: var(--px-15);
			.show-popup-arrow {
				left: auto;
				right: var(--px-20);
			}
		}
	}
	&:nth-child(5) {
		.show-pop-content.bottom.left {
			left: auto;
			right: var(--px-15);
			.show-popup-arrow {
				left: auto;
				right: var(--px-20);
			}
		}
	}
`;
